import { Route, Routes } from 'react-router-dom';
import Notifications from '../components/Notification/Notification';
import DetailProgramNotification from '../components/detail-program-notification/detail-program-notification';

export const RoutesNotification = ({ changeNotifications }: any) => {
  return (
    <>
      <Routes>
        <Route
          path='/'
          element={<Notifications changeNotifications={changeNotifications} />}
        />
        <Route
          path='detailProgramNotification/:id'
          element={
            <DetailProgramNotification
              changeNotifications={changeNotifications}
            />
          }
        />
      </Routes>
    </>
  );
};
